export default __webpack_public_path__ + "static/media/cheesemantle.5213895c.jpg";